import './style.scss';
import { gsap } from "gsap";


export function headerBlock() {
    const header = document.querySelector('header');
    if (!header) return;

    const navbar = header?.querySelector(".navbar");
    const menuItems = header?.querySelectorAll(".menu-item.menu-item-has-children");
    const burgerMenu = header?.querySelector('.burger-menu');
    const isDesktop = window.innerWidth >= 1024;

    window.addEventListener('resize', () => {
        if (isDesktop) {
            document.documentElement.classList.remove('modal-opened');
            const burgerMenu = header?.querySelector('.burger-menu');
            const navbar = header.querySelector('.navbar');

            if (burgerMenu?.classList.contains('burger-menu-active')) {
                burgerMenu.classList.remove('burger-menu-active');
                navbar?.classList.remove('header-links-active');
                header?.classList.remove('header-active');
                document.querySelectorAll('.menu-item').forEach(item => item.classList.remove('active-menu'));
            }
        }
    });


    //region Burger Menu

    if (!burgerMenu) return;
    const burgerSpans = burgerMenu.querySelectorAll('span');
    const burgerTl = gsap.timeline({ paused: true });
    gsap.set(burgerSpans, { transformOrigin: 'center center' }); // Updated alignment
    burgerTl
        .to(burgerSpans[0], { y: 4, rotation: 45, duration: 0.25 }, 0) // Adjusted y value
        .to(burgerSpans[1], { y: -4, rotation: -45, duration: 0.25 }, 0); // Adjusted y value


    //Burger Menu Clicking

    burgerMenu.addEventListener('click', function () {
        if (burgerMenu.classList.contains('burger-menu-active')) {
            burgerMenu.classList.remove('burger-menu-active');
            closeHeaderModal()
            burgerTl.reverse();

        } else {
            burgerMenu.classList.add('burger-menu-active');
            navbar.classList.add('navbar-active');
            header.classList.add('header-active');
            document.documentElement.classList.add('modal-opened');
            burgerTl.play();
        }
    });
    // endregion


    menuItems.forEach((menuItem) => {
        menuItem.addEventListener("click", (e) => {
            const isActive = menuItem.classList.contains("active-menu");
            menuItems.forEach(item => item.classList.remove("active-menu"));

            if (!isActive) {
                if (!isDesktop) {

                    document.documentElement.classList.add('modal-opened');
                }
                menuItem.classList.add("active-menu");
                header.classList.add("header-active");
                navbar.classList.add("navbar-active");
            } else {
                if (isDesktop) {
                    closeHeaderModal()
                } else if (window.innerWidth < 1024) {
                    document.documentElement.classList.remove('modal-opened');
                }
            }

        });
    });

    function closeHeaderModal() {
        document.documentElement.classList.remove('modal-opened');
        if (header) header.classList.remove('header-active');
        if (navbar) navbar.classList.remove('navbar-active');
        document.querySelectorAll('.menu-item').forEach(item => item.classList.remove('active-menu'));
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === "Escape") {
            closeHeaderModal();
        }
    });

    document.querySelectorAll('.sub-menu').forEach(menu => {
        menu.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });

    document.addEventListener('click', (e) => {
        if (isDesktop) {

            if (e.target.closest('.sub-menu'))
                return;


            if (header.contains(e.target)) return;

            closeHeaderModal();
        }
    });

    //    Back Step
    const backSteps = header?.querySelectorAll(".back-step");
    backSteps.forEach(step => {
        step.addEventListener("click", () => {
            document.querySelectorAll('.menu-item').forEach(item => item.classList.remove('active-menu'));
            if (window.innerWidth < 1024) {
                document.documentElement.classList.remove('modal-opened');
            }
        });
    });
}

